export const isFullLenght = (mediaComposition, urn) => mediaComposition.getMainChapter().urn === urn;
export const findSegment = (mediaComposition, urn) => mediaComposition.getSubdivisions().find(subdivision => subdivision.urn === urn);
export const findMedia = (mediaComposition, urn) => {
  if (isFullLenght(mediaComposition, urn)) {
    return mediaComposition.getMainChapter();
  }
  return findSegment(mediaComposition, urn);
};